import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TalentPlat from '@/components/techView/TalentPlat.vue'
// import WOW from 'wowjs'
import {getTechPlatform} from '@/api/product'
import { onMounted } from "vue"
// onMounted(() => {
//   getTechPlatform().then(res=>{
//     console.log(res);
//   })
// })

export default /*#__PURE__*/_defineComponent({
  __name: 'TechView',
  setup(__props) {

// import PatentsView from '@/components/techView/PatentsView.vue'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TalentPlat))
}
}

})